// extracted by mini-css-extract-plugin
export default {"negMargin":"Contact_negMargin__tmz6C"};